/// <reference types="vite-plugin-svgr/client" />
import { Heading } from '@spark-web/heading';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import Logo from './image/logo.svg?react';
import ErrorImage from './image/maintenance.svg?react';

type MaintenanceProps = {
  endDate?: string;
  endTime?: string;
  enabled?: boolean;
  children?: React.ReactNode;
};

const Maintenance = ({ enabled = false, endDate, endTime, children }: MaintenanceProps) => {
  return enabled ? (
    <>
      <Stack gap="xxlarge" alignSelf="center">
        <Logo />
      </Stack>
      <Stack gap="xxlarge" padding="xlarge" marginBottom="xlarge">
        <Stack align="center" gap="xlarge">
          <ErrorImage />
        </Stack>
        <Heading align="center" level="1">
          We’ll be back in a bit.
        </Heading>

        <Text align="center" weight="semibold">
          Brighte is currently undergoing maintenance to ensure you get the best finance application experience.
        </Text>

        <Stack align="center" gap="large">
          {endDate && endTime && (
            <Text size="small">
              The maintenance is expected to run until {endTime} on {endDate}.
            </Text>
          )}
          <Text>Thank you for your patience and understanding.</Text>
          <Text weight="semibold">Brighte Team</Text>
        </Stack>
      </Stack>
    </>
  ) : (
    <>{children}</>
  );
};

export default Maintenance;
